import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformId } from '@lsq-frontend/fasttrack-shared/app-constants';
import { supplyChainPlatformNode } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WhiteLabel } from '../white-label';
import { WhiteLabelRule } from '../white-label-rule';

@Injectable()
export class SupplyChainPlatformWhiteLabelRule implements WhiteLabelRule {
    public whiteLabelRule$: Observable<WhiteLabel> = this._router.events.pipe(
        map((_) => {
            // The router is nested in the MFE structure, not sure why it's nested this deep but this is only way to find the route params.
            const currentSnapshot = this._activatedRoute.firstChild?.snapshot.firstChild
                ?.firstChild;

            if (currentSnapshot?.routeConfig?.path !== supplyChainPlatformNode.path) {
                return {};
            }

            const params = currentSnapshot.params;

            if (params['platformId'].toLowerCase() === PlatformId.COUNSEL_LINK.toLowerCase()) {
                return {
                    scfPlatformPlatformName: 'CounselLink',
                    scfPlatformProductName: 'FastTrack',
                    navbarCoBrandLogoAssetPath:
                        'apps/fasttrack/src/assets/images/counsellink_fasttrack_logo_red.svg',
                    navbarCoBrandStackedLogoAssetPath:
                        'apps/fasttrack/src/assets/images/counsellink_logo_stacked_red.svg',
                    whiteLabelClassName: 'counselLink-brand-theme',
                    navbarMainBrandLogoIconConfig: undefined,
                    scfPlatformLoginUrl: 'https://counsellink.net/aui/index.html#/login',
                    isTimeoutPageWhiteLabeled: true
                };
            } else if (params['platformId'].toLowerCase() === PlatformId.LSS.toLowerCase()) {
                return {
                    scfPlatformPlatformName: 'LSS',
                    scfPlatformProductName: 'RapidPay',
                    navbarCoBrandLogoAssetPath:
                        'apps/fasttrack/src/assets/images/dxc_logo_black.png',
                    navbarCoBrandStackedLogoAssetPath:
                        'apps/fasttrack/src/assets/images/dxc_logo_black.png',
                    navbarCoBrandLogoConfig: {
                        heightPx: 30
                    },
                    navbarMainBrandLogoIconConfig: undefined,
                    scfPlatformLoginUrl: 'https://www.google.com',
                    isTimeoutPageWhiteLabeled: false
                };
            } else if (
                params['platformId'].toLowerCase() === PlatformId.TEST_PLATFORM.toLowerCase()
            ) {
                return {
                    scfPlatformPlatformName: 'Test Platform',
                    scfPlatformProductName: 'FastTrack',
                    navbarCoBrandLogoAssetPath:
                        'apps/fasttrack/src/assets/images/counsellink_fasttrack_logo_red.svg',
                    navbarCoBrandStackedLogoAssetPath:
                        'apps/fasttrack/src/assets/images/counsellink_logo_stacked_red.svg',
                    whiteLabelClassName: 'counselLink-brand-theme',
                    navbarMainBrandLogoIconConfig: undefined,
                    scfPlatformLoginUrl: 'https://counsellink.net/aui/index.html#/login',
                    isTimeoutPageWhiteLabeled: true
                };
            }
            return {};
        })
    );

    constructor(private _router: Router, private _activatedRoute: ActivatedRoute) {}
}
